import React, { Component } from 'react';
import ReactSlick from 'react-slick';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { t } from 'ttag';
import Pagination from './pagination/pagination';
import * as overlayActions from '../overlayFull/overlayActions';
import * as galleryActions from './galleryActions';

import './slick.less';

class MobileZoom extends Component {
  componentDidMount() {
    this.props.RERENDER_GALLERY(false);
  }

  componentWillUnmount() {
    this.props.RERENDER_GALLERY(true);
  }

  render() {
    const { images, title } = this.props.app.data;
    const { activeImage, pageYOffset } = this.props;
    return (
      <div id="zoomish">
        <div className="zoomedMobile" />
        <div
          className="overlayClose"
          onClick={() => this.props.CLOSE_OVERLAY(pageYOffset)}
          role="button"
          tabIndex="0"
          style={{ outline: 'none' }}
          aria-label={t`Close Overlay`}
        />
        <div className="slickComponent mobile">
          <div className="mainSliderHolder" data-testid="product-slider">
            <ReactSlick
              className="mainSlider"
              dots={false}
              afterChange={(current) => this.props.IMAGE_CONTROLLER(current)}
              infinite={false}
              arrows={false}
              speed={200}
              initialSlide={activeImage}
              touchThreshold={10}
              lazyLoad
            >
              {images.gallery.map((item) => {
                return (
                  <div className="galleryImage" key={item.image}>
                    <img src={item.image} alt={title} />
                  </div>
                );
              })}
              {/* {images.gallery.map((item, i) => {
              return (
                <div className="zoomDiv" key={item.thumb}>
                <ReactImageMagnify
                  enlargedImageContainerStyle={{ overflow: 'visible' }}
                  smallImage={{
                    alt: `${title} ${i}`,
                    isFluidWidth: true,
                    src: item.image,
                    srcSet: this.srcSet,
                  }}
                  largeImage={{
                    alt: `${title} ${i} large`,
                    src: item.image,
                    width: 600,
                    height: 600,
                  }}
                />
                </div>
              );
            })} */}
            </ReactSlick>
            <Pagination />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ app, gallery, overlayFull }) => {
  return {
    app,
    gallery,
    activeImage: gallery.activeImage,
    pageYOffset: overlayFull.pageYOffset,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...galleryActions, ...overlayActions }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileZoom);
